var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('external-link',{attrs:{"href":("https://curation.clinicalgenome.org/curation-central/" + (_vm.curation.gdm_uuid)),"target":"gci"}},[_vm._t("default",[_vm._v(_vm._s(_vm.curation.gdm_uuid))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }